import { AppContext } from 'App.context.js';
import React, { useContext } from 'react';
import styles from './DynamicFormsHeader.styles.js';
import { UserOutlined } from '@ant-design/icons';
import childIcon from '../../../../../assets/images/icons/blue/abc-block.png';

export default function DynamicFormsHeader({ guestType, first, last, size }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const getIconForGuestType = (type) => {
    const iconStyle = { marginRight: 4, width: 16, height: 16 };

    if (type.includes('child')) {
      return (
        <img src={childIcon} alt="child-icon" style={{ ...iconStyle, filter: 'brightness(0)' }} />
      );
    }
    
    return <UserOutlined style={{ ...iconStyle, fontSize: 16, color: 'black' }} />;
  };

  return (
    <div style={{ ...styles.wrapper, minWidth: size, maxWidth: size }}>
      <div
        style={{
          ...styles.guestType,
        }}
      >
        {getIconForGuestType(guestType)}
        {translate(`dynamicForms.guestType.${guestType}`)}
      </div>
      <div
        style={{
          ...styles.container,
        }}
      >
        <div style={{ marginLeft: 8 }}>{translate(`dynamicForms.visible`)}</div>
        <div>{translate(`dynamicForms.required`)}</div>
      </div>
    </div>
  );
}
